import {TimeLogs} from 'components/User';
import {connect} from 'react-redux';
import {getCaseTimeLogByUserPayPeriod, getPayPeriodList} from 'actions/casetimelog';

const mapStateToProps = (state) =>  {
    return {
        isFetchingTimeLogs: state.caseTimeLog.isFetchingTimeLogs,
        timeLogs: state.caseTimeLog.timeLogs,
        isFetchingPayPeriods: state.caseTimeLog.isFetchingPayPeriods,
        payPeriods: state.caseTimeLog.payPeriods
    };
};

const mapDispatchToProps = (dispatch) => ({
    getCaseTimeLogByUserPayPeriod (internetUserId, payPeriodId) {
        dispatch(getCaseTimeLogByUserPayPeriod(internetUserId, payPeriodId));
    },


    getPayPeriodList () {
        dispatch(getPayPeriodList());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeLogs);